import React from 'react';

const IconHeartSimple = () => (
  <svg
    width="121"
    height="120"
    viewBox="0 0 121 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Heart Simple</title>
    <path
      d="M61.7492 40.3535C48.4582 -1.94488 22.9434 5.33123 15.8613 10.473C3.73445 19.2043 -10.9148 56.2639 63.2044 119.129C137.421 56.2639 122.674 19.2043 110.548 10.473C103.466 5.33123 77.9507 -1.94488 64.6597 40.3535C64.4656 41.0326 63.7865 41.4207 63.2044 41.4207C62.5253 41.4207 61.9432 41.0326 61.7492 40.3535Z"
      fill="#C8102E"
    />
    <path
      d="M59.2271 117.092L58.257 116.316C9.26455 74.7937 -0.14587 45.4952 0.533233 28.1296C1.11532 13.5774 8.68245 6.98041 11.0108 5.33116C14.6974 2.71177 23.4287 -0.877777 33.3242 2.42072C44.6749 6.20429 53.4062 17.458 59.2271 35.9878L57.2868 36.5699L59.2271 35.9878H59.3241C65.145 17.458 73.8763 6.10727 85.227 2.3237C95.0255 -0.974797 103.854 2.61475 107.54 5.23414C109.869 6.88339 117.436 13.4804 118.018 28.0326C118.697 45.3012 109.19 74.6966 60.2943 116.219L59.2271 117.092ZM25.369 3.97295C19.6451 3.97295 14.9884 6.10727 12.7571 7.65951C8.58544 10.667 3.92875 17.749 3.44367 28.2266C2.76457 44.8161 11.981 72.9504 59.2271 113.211C106.473 72.8534 115.69 44.7191 115.011 28.2266C114.622 17.749 109.966 10.667 105.697 7.65951C102.69 5.52519 94.8315 2.2267 86.0031 5.13714C75.7196 8.53265 67.3763 19.4953 61.9435 36.8609C61.5554 38.1221 60.3913 38.8982 59.1301 38.8982C57.8689 38.8982 56.7047 38.0251 56.3167 36.8609C50.8838 19.4953 42.5406 8.53265 32.257 5.13714C29.9287 4.36102 27.6003 3.97295 25.369 3.97295Z"
      fill="#3F2021"
    />
  </svg>
);

export default IconHeartSimple;
